import React, { Component, createRef } from "react";
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody
} from "reactstrap";
import _ from "lodash";
import classnames from "classnames";
import PublicationForm from "./Form";
import PublicationPreview from "./Preview";
import { saveCourse, switchState } from "./Axios";
import Notifications from "../commons/Notifications";

// Función helper para sanitizar HTML y remover font-family y font-size (puede usarse en constructor)
const sanitizeHTML = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value !== 'string') return value;
  
  let sanitized = value
    .replace(/<script[^>]*>.*?<\/script>/gi, '') // Remover scripts completos
    .replace(/javascript:/gi, '') // Remover javascript:
    .replace(/on\w+\s*=/gi, '') // Remover event handlers
    .replace(/<iframe[^>]*>.*?<\/iframe>/gi, '') // Remover iframes completos
    .replace(/<object[^>]*>.*?<\/object>/gi, '') // Remover objects completos
    .replace(/<embed[^>]*>/gi, '') // Remover embeds
    .replace(/expression\s*\(/gi, '') // Remover CSS expressions
    .replace(/eval\s*\(/gi, '') // Remover eval
    .replace(/import\s*\(/gi, '') // Remover dynamic imports
    .trim();

  // Normalizar estilos HTML: remover font-family, font-size, background-color y otros estilos problemáticos
  sanitized = sanitized.replace(/style\s*=\s*["']([^"']*)["']/gi, (match, styleContent) => {
    // Remover font-family, font-size, background-color y otros estilos problemáticos
    const cleanedStyle = styleContent
      .replace(/font-family\s*:\s*[^;]+;?/gi, '') // Remover font-family
      .replace(/font-size\s*:\s*[0-9.]+pt;?/gi, '') // Remover font-size en pt
      .replace(/font-size\s*:\s*[0-9.]+px;?/gi, '') // Remover font-size en px
      .replace(/background-color\s*:\s*[^;]+;?/gi, '') // Remover background-color
      .replace(/;\s*;/g, ';') // Limpiar dobles punto y coma
      .replace(/^\s*;\s*|\s*;\s*$/g, '') // Remover punto y coma al inicio/final
      .trim();

    // Si el estilo queda vacío, remover el atributo completo
    if (!cleanedStyle) {
      return '';
    }
    return `style="${cleanedStyle}"`;
  });

  // Limpiar espacios en blanco extra que puedan quedar
  sanitized = sanitized.replace(/\s+/g, ' ').trim();

  return sanitized;
};

class PublicationStepperForm extends Component {
  constructor(props) {
    super(props);

    const { course , default_questions} = this.props;

    this.notificationsRef = createRef();

    this.state = {
      activeTab: "publicationForm",
        course: {
        id: { value: course ? course.id : null },
        title: { value: course ? course.title : "", errors: [] },
        contractType: {
          value: course ? course.contractType.value : "",
          label: course ? course.contractType.label : "",
          errors: []
        },
        jobDescription: {
          value: course && course.jobDescription ? sanitizeHTML(course.jobDescription) : "",
          errors: []
        },
        vacancies: { value: course ? course.vacancies : "", errors: [] },
          createdById: course ? course.createdById : null,
        minisitePublication: {
          id: {value: course ? course.minisitePublication.id : null},
          aasmState: {
            value: course ? course.minisitePublication.aasmState : null
          },
          country: {
            value: course ? course.minisitePublication.country.id : "",
            label: course ? course.minisitePublication.country.name : "",
            errors: []
          },
          region: {
            value: course ? course.minisitePublication.region.id : "",
            label: course ? course.minisitePublication.region.name : "",
            errors: []
          },
          commune: {
            value: course ? course.minisitePublication.commune.id : "",
            label: course ? course.minisitePublication.commune.name : "",
            errors: []
          },
          division: {
            value: course ? course.minisitePublication.division.id : "",
            label: course ? course.minisitePublication.division.name : "",
            errors: []
          },
          management: {
            value: course ? course.minisitePublication.management.id : "",
            label: course ? course.minisitePublication.management.name : "",
            errors: []
          },
          position: {
            value: course ? course.minisitePublication.position.id : "",
            label: course ? course.minisitePublication.position.name : "",
            errors: []
          },
          head: {
            value: course ? course.minisitePublication.head.id : "",
            label: course ? course.minisitePublication.head.name : "",
            errors: []
          },
          employeeReplacement: {
            value: course ? course.minisitePublication.employeeReplacement.id : "",
            label: course ? course.minisitePublication.employeeReplacement.name : "",
            errors: []
          },
          address: {
            value: course ? course.minisitePublication.address : "",
            errors: []
          },
          desactivateAt: {
            value: course ? course.minisitePublication.desactivateAt : "",
            errors: []
          },
          preferredSchedule: {
            value: course ? course.minisitePublication.preferredSchedule : "",
            errors: []
          },
          preferredLaborDay: {
            value: course ? course.minisitePublication.preferredLaborDay : "",
            errors: []
          },
          preferredTurn: {
            value: course ? course.minisitePublication.preferredTurn : "",
            errors: []
          },
          dressCode: {
            value: course ? course.minisitePublication.dressCode : "",
            errors: []
          },
          requestReason: {
            value: course ? course.minisitePublication.requestReason : "",
            errors: []
          },
          mapping: {
            value: course?.mapping?.id || "",
            label: course?.mapping?.label || "No asignado",
            errors: []
          },
          replacementReason: {
            value: course ? course.minisitePublication.replacementReason : "",
            errors: []
          },
          fixedTermReason: {
            value: course ? course.minisitePublication.fixedTermReason : "",
            errors: []
          },
          requestingCompany: {
            value: course ? course.minisitePublication.requestingCompany : "",
            errors: []
          },
          searchType: {
            value: course ? course.minisitePublication.searchType : "",
            errors: []
          },
          recruiter: {
            value: course ? (course.createdById || "") : "",
            label: course ? (course.minisitePublication.recruiter || course.createdByEmail || "") : "",
            errors: []
          },
          location: {
            value: course ? course.minisitePublication.location : "",
            errors: []
          },
          bukId: {
            value: course ? course.minisitePublication.bukId : "",
            errors: []
          },
          profilePositionFile: {
            value: null,
            errors: []
          },
          profilePositionFileUrl: course && course.minisitePublication.profilePositionFileUrl
            ? course.minisitePublication.profilePositionFileUrl
            : null,
          profilePositionFileName: course && course.minisitePublication.profilePositionFileName
            ? course.minisitePublication.profilePositionFileName
            : null,
          positionFamily: {
            value: course ? course.minisitePublication.positionFamily : "",
            errors: []
          },
          vacancyRequester: {
            value: course ? course.minisitePublication.vacancyRequester : "",
            errors: []
          },
          isConfidential: {
            value: course ? course.minisitePublication.isConfidential : "",
            errors: []
          },
          educationLevel: {
            value: course
              ? course.minisitePublication.educationLevel.value
              : "",
            label: course
              ? course.minisitePublication.educationLevel.label
              : "",
            errors: []
          },
          requirements: {
            value: course && course.minisitePublication.requirements ? sanitizeHTML(course.minisitePublication.requirements) : "",
            errors: []
          },
          knowledges: {
            value: course && course.minisitePublication.knowledges ? sanitizeHTML(course.minisitePublication.knowledges) : "",
            errors: []
          },
          benefits: {
            value: course && course.minisitePublication.benefits ? sanitizeHTML(course.minisitePublication.benefits) : "",
            errors: []
          },
          experienceYears: {
            value: course ? course.minisitePublication.experienceYears : null,
            errors: []
          },
          publicationQuestions: course
            ? course.minisitePublication.publicationQuestions.map(q => ({
              id: q.id || "",
              value: q.name || q.value,
              answerType: q.answer_type || q.answerType || "text",
              options: Array.isArray(q.options)
                ? q.options
                : (typeof q.options === "string" && q.options.trim().startsWith("["))
                  ? JSON.parse(q.options)
                  : [],
              errors: [],
              optionsErrors: [],
              destroy: false,
              isDefault: q.is_default === true
            }))
            : default_questions.map(question => ({
              id: "",
              value: question.question,
              answerType: question.answer_type || "text",
              options: Array.isArray(question.options)
                ? question.options
                : (typeof question.options === "string" && question.options.trim().startsWith("["))
                  ? JSON.parse(question.options)
                  : [],
              errors: [],
              optionsErrors: [],
              destroy: false,
              isDefault: question.is_default === true
            })),

          deletedPublicationQuestions: []
        },
      }
    };
  }

  showNotification = (title, message, type) => {
    if (this.notificationsRef.current) {
      this.notificationsRef.current.addNotifications(title, message, type);
    }
  };

  handleChangeCourse = (e, fieldName = null) => {
    const { course } = this.state;
    if (fieldName) {
      course[fieldName]["value"] = e.value;
      course[fieldName]["label"] = e.label;
      course[fieldName]["errors"] = [];
    } else {
      course[e.target.name]["value"] = e.target.value;
      course[e.target.name]["errors"] = [];
    }

    this.setState({ course });
  };

  handleAddQuestion = (value, isDefault, answerType = "text") => {
    let { course } = this.state;
    course.minisitePublication.publicationQuestions.push({
      id: "",
      value: value,
      answerType: answerType,
      errors: [],
      destroy: false,
      isDefault: isDefault
    });
    this.setState({
      ...this.state.course,
      course
    });
  };

  handleRemoveQuestion = id => {
    let { course } = this.state;
    if (course.minisitePublication.publicationQuestions[id].id) {
      course.minisitePublication.publicationQuestions[id].destroy = true;
      course.minisitePublication.deletedPublicationQuestions.push(
        course.minisitePublication.publicationQuestions[id]
      );
    }
    course.minisitePublication.publicationQuestions.splice(id, 1);
    this.setState({
      ...this.state.course,
      course
    });
  };

  handleChangeQuestion = (value, id) => {
    let { course } = this.state;
    course.minisitePublication.publicationQuestions[id]["value"] = value;
    course.minisitePublication.publicationQuestions[id]["errors"] = [];
    this.setState({
      ...this.state.course,
      course
    });
  };

  handleChangeQuestionField = (field, value, index) => {
    const { course } = this.state;

    // --- NUEVO BLOQUE PARA REORDER ---
    if (field === "reorder") {
      // value es el array de preguntas reordenadas
      course.minisitePublication.publicationQuestions = value;
      this.setState({ course });
      return;
    }
    // --- FIN NUEVO BLOQUE ---

    const question = course.minisitePublication.publicationQuestions[index];

    // Si el tipo cambia a single o multiple choice, asegúrate de tener options
    if (field === "answerType") {
      question[field] = value;
      if (["single_choice", "multiple_choice"].includes(value)) {
        if (!Array.isArray(question.options)) question.options = [];
      } else {
        question.options = [];
      }
      this.setState({ course });
      return;
    }

    question[field] = value;
    this.setState({ course });
  };

  handleChangeMinisitePublication = (e, fieldName = null) => {
    const { course } = this.state;
    if (fieldName === "profilePositionFile") {
      course["minisitePublication"][fieldName]["value"] = e;
      course["minisitePublication"][fieldName]["errors"] = [];
      this.setState({ course });
      return;
    }
    if (fieldName === "isConfidential") {
      course["minisitePublication"][fieldName]["value"] = e;
      course["minisitePublication"][fieldName]["errors"] = [];
    } else if (fieldName) {
      if (!course["minisitePublication"][fieldName]) {
        course["minisitePublication"][fieldName] = { value: "", label: "", errors: [] };
      }
      course["minisitePublication"][fieldName]["value"] = e.value;
      course["minisitePublication"][fieldName]["label"] = fieldName === "recruiter" ? (e.email || e.label) : e.label;
      course["minisitePublication"][fieldName]["uniqueIdentifier"] = e.uniqueIdentifier;
      course["minisitePublication"][fieldName]["errors"] = [];
      if (fieldName === "recruiter") {
        course.createdById = e.value || course.createdById;
      }
    } else {
      const fieldName = e.target.name;
      let fieldValue = e.target.value;
      
      // Sanitizar campos HTML en tiempo real (requirements, knowledges, etc.)
      const htmlFields = ['requirements', 'knowledges'];
      if (htmlFields.includes(fieldName) && typeof fieldValue === 'string' && fieldValue.includes('<')) {
        fieldValue = sanitizeHTML(fieldValue);
      }
      
      course["minisitePublication"][fieldName]["value"] = fieldValue;
      course["minisitePublication"][fieldName]["errors"] = [];
    }

    const setDateError = () => {
      const val = course.minisitePublication.desactivateAt.value;
      if (!val) {
        course.minisitePublication.desactivateAt.errors = ["Debe seleccionar una fecha"];
        return;
      }
      const picked = new Date(val);
      const today  = new Date(); today.setHours(0,0,0,0);
      if (isNaN(picked.getTime()) || picked < today) {
        course.minisitePublication.desactivateAt.errors = ["La fecha debe ser hoy o futura"];
      } else {
        course.minisitePublication.desactivateAt.errors = [];
      }
    };

    if (fieldName === "desactivateAt" || (e?.target?.name === "desactivateAt")) {
      setDateError();
    }
    
    this.setState({ course });
  };

  handleChangeJobDescription = description => {
    const { course } = this.state;
    // Sanitizar el contenido en tiempo real para que la vista previa muestre el contenido limpio
    course.jobDescription.value = sanitizeHTML(description);
    course.jobDescription.errors = [];
    this.setState({ course });
  };

  handleChangeBenefits = benefits => {
    const { course } = this.state;
    // Sanitizar el contenido en tiempo real para que la vista previa muestre el contenido limpio
    course.minisitePublication.benefits.value = sanitizeHTML(benefits);
    course.minisitePublication.benefits.errors = [];
    this.setState({ course });
  };

  handleContinueWithoutPublishing = (e) => {
    e?.preventDefault?.();

    const { course } = this.state;

    // Si por alguna razón no hay ID, avisamos (en el flujo normal, ya existe)
    if (!course.id.value) {
      this.showNotification("Ops", "Primero debes guardar la oferta para continuar.", "warning");
      this.toggleTab("publicationForm");
      return;
    }

    // Redirige al show del curso sin publicar
    window.location.href = `/courses/${course.id.value}`;
  };


  toggleTab = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({
        ...this.state,
        activeTab: tab
      });
    }
  };

  serializeData = async () => {
    const { course } = this.state;
    const hasFile = course.minisitePublication.profilePositionFile?.value instanceof File;

    course.minisitePublication.publicationQuestions.forEach(q => {
      if (!Array.isArray(q.options)) {
        if (typeof q.options === "string" && q.options.trim().startsWith("[")) {
          try {
            q.options = JSON.parse(q.options);
          } catch (e) {
            q.options = [];
          }
        } else {
          q.options = [];
        }
      }
    });

    // Construir los datos base
    const data = this.buildCourseJSON();

    // Si hay archivo, convertirlo a Base64 y agregarlo al JSON
    if (hasFile) {
      const file = course.minisitePublication.profilePositionFile.value;

      // Validar tamaño (5MB máximo)
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        throw new Error(`El archivo es demasiado grande (${(file.size / 1024 / 1024).toFixed(2)}MB). El tamaño máximo permitido es 5MB.`);
      }

      // Convertir archivo a Base64
      const base64 = await this.fileToBase64(file);

      // Agregar al JSON
      data.course.minisite_publication_attributes.profile_position_file_base64 = base64;
      data.course.minisite_publication_attributes.profile_position_filename = file.name;
      data.course.minisite_publication_attributes.profile_position_content_type = file.type;
    }

    return data;
  };

  fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };

  buildCourseJSON = () => {
    const { course } = this.state;

    // Función helper para sanitizar valores (usa el método sanitizeHTML para HTML, o devuelve el valor tal cual)
    const sanitizeValue = (value) => {
      if (value === null || value === undefined) return null;
      if (typeof value === 'string') {
        // Si parece ser HTML, usar sanitizeHTML, sino devolver tal cual
        if (value.includes('<') && value.includes('>')) {
          return sanitizeHTML(value);
        }
        // Para valores de texto plano, solo remover patrones peligrosos básicos
        return value
          .replace(/<script[^>]*>.*?<\/script>/gi, '')
          .replace(/javascript:/gi, '')
          .replace(/on\w+\s*=/gi, '')
          .trim();
      }
      return value;
    };

    // Función helper para sanitizar números
    const sanitizeNumber = (value) => {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      const num = parseFloat(value);
      return isNaN(num) ? null : num;
    };

    // Función helper para mapear education_level a valores numéricos del enum
    const mapEducationLevel = (value) => {
      if (!value) return null;

      const educationLevelMap = {
        'special_education': 0,
        'primary_incomplete': 1,
        'primary_complete': 2,
        'secondary_incomplete': 3,
        'secondary_complete': 4,
        'higher_incomplete': 5,
        'higher_complete': 6
      };

      // Si ya es un número, devolverlo
      if (typeof value === 'number') return value;

      // Si es un string del enum, mapearlo al número correspondiente
      if (typeof value === 'string' && educationLevelMap[value] !== undefined) {
        return educationLevelMap[value];
      }

      // Si es un string numérico, parsearlo
      const num = parseFloat(value);
      return isNaN(num) ? null : num;
    };

    const data = {
      course: {
        title: sanitizeValue(course.title.value),
        contract_type: sanitizeValue(course.contractType.value),
        job_description: sanitizeValue(course.jobDescription.value),
        vacancies: sanitizeNumber(course.vacancies.value),
        mapping_id: sanitizeNumber(course.minisitePublication.mapping?.value),
        minisite_publication_attributes: {
          title: sanitizeValue(course.title.value),
          address: sanitizeValue(course.minisitePublication.address.value),
          territory_commune_id: sanitizeNumber(course.minisitePublication.commune.value),
          desactivate_at: course.minisitePublication.desactivateAt.value,
          position_id: sanitizeNumber(course.minisitePublication.position.value),
          head_id: sanitizeNumber(course.minisitePublication.head.value),
          employee_replacement_id: sanitizeNumber(course.minisitePublication.employeeReplacement.value),
          management_id: sanitizeNumber(course.minisitePublication.management.value),
          request_reason: sanitizeValue(course.minisitePublication.requestReason.value),
          replacement_reason: sanitizeValue(course.minisitePublication.replacementReason.value),
          fixed_term_reason: sanitizeValue(course.minisitePublication.fixedTermReason.value),
          requesting_company: sanitizeValue(course.minisitePublication.requestingCompany.value),
          search_type: sanitizeValue(course.minisitePublication.searchType.value),
          buk_id: sanitizeValue(course.minisitePublication.bukId.value),
          recruiter: sanitizeValue(course.minisitePublication.recruiter.label),
          location: sanitizeValue(course.minisitePublication.location.value),
          position_family: sanitizeValue(course.minisitePublication.positionFamily.value),
          vacancy_requester: sanitizeValue(course.minisitePublication.vacancyRequester.value),
          preferred_schedule: sanitizeValue(course.minisitePublication.preferredSchedule.value),
          preferred_labor_day: sanitizeValue(course.minisitePublication.preferredLaborDay.value),
          preferred_turn: sanitizeValue(course.minisitePublication.preferredTurn.value),
          dress_code: sanitizeValue(course.minisitePublication.dressCode.value),
          is_confidential: Boolean(course.minisitePublication.isConfidential.value),
          education_level: mapEducationLevel(course.minisitePublication.educationLevel.value),
          requirements: sanitizeValue(course.minisitePublication.requirements.value),
          knowledges: sanitizeValue(course.minisitePublication.knowledges.value),
          benefits: sanitizeValue(course.minisitePublication.benefits.value),
          experience_years: sanitizeNumber(course.minisitePublication.experienceYears.value),
          publication_questions_attributes: []
        }
      }
    };

    if (course.id.value) {
      data.course.id = course.id.value;
    }

    if (course.minisitePublication.id.value) {
      data.course.minisite_publication_attributes.id = course.minisitePublication.id.value;
    }

    if (course.minisitePublication.publicationQuestions.length > 0) {
      data.course.minisite_publication_attributes.publication_questions_attributes =
        course.minisitePublication.publicationQuestions.map(question => ({
          id: sanitizeNumber(question.id),
          name: sanitizeValue(question.value),
          _destroy: Boolean(question.destroy),
          is_default: Boolean(question.isDefault),
          answer_type: sanitizeValue(question.answerType || question.answer_type || "text"),
          options: JSON.stringify((question.options || []).map(opt => sanitizeValue(opt)))
        }));
    }

    if (course.minisitePublication.deletedPublicationQuestions.length > 0) {
      data.course.minisite_publication_attributes.publication_questions_attributes.push(
        ...course.minisitePublication.deletedPublicationQuestions.map(question => ({
          id: sanitizeNumber(question.id),
          name: sanitizeValue(question.value),
          _destroy: Boolean(question.destroy)
        }))
      );
    }

    return data;
  };

  serializeAsJSON = () => {
    return this.buildCourseJSON();
  };



  setErrors = errors => {
    const { course } = this.state;
    course.minisitePublication.bukId.errors =
      errors["minisite_publication.buk_id"];
    course.title.errors = errors.title;
    course.jobDescription.errors = errors.job_description;
    course.vacancies.errors = errors.vacancies;
    course.minisitePublication.position.errors =
      errors["minisite_publication.position"];
    course.minisitePublication.head.errors =
      errors["minisite_publication.head"];
    course.minisitePublication.management.errors =
      errors["minisite_publication.management"];
    course.minisitePublication.requestReason.errors =
      errors["minisite_publication.request_reason"];
    const reason = course.minisitePublication.requestReason.value;

    // Mapear errores de employee_replacement (puede venir como employee_replacement o employee_replacement_id)
    const employeeReplacementError =
      errors["minisite_publication.employee_replacement"] ||
      errors["minisite_publication.employee_replacement_id"];

    if (reason === "replacement") {
      course.minisitePublication.replacementReason.errors =
        errors["minisite_publication.replacement_reason"] || ["Debe indicar el motivo del reemplazo"];
      course.minisitePublication.employeeReplacement.errors =
        employeeReplacementError || ["Debe indicar a quién reemplaza"];
    }

    if (reason === "fix_term") {
      course.minisitePublication.fixedTermReason.errors =
        errors["minisite_publication.fixed_term_reason"] || ["Debe indicar el motivo del plazo fijo"];
      course.minisitePublication.employeeReplacement.errors =
        employeeReplacementError || ["Debe indicar a quién reemplaza"];
    }

    // También establecer el error si viene en los errores generales (independientemente del reason)
    if (employeeReplacementError) {
      course.minisitePublication.employeeReplacement.errors = employeeReplacementError;
    }
    course.minisitePublication.requestingCompany.errors =
      errors["minisite_publication.requesting_company"];
    course.minisitePublication.searchType.errors =
      errors["minisite_publication.search_type"];
    course.minisitePublication.bukId.errors =
      errors["minisite_publication.buk_id"];
    course.minisitePublication.recruiter.errors =
      errors["minisite_publication.recruiter"];
    course.minisitePublication.location.errors =
      errors["minisite_publication.location"];
    course.minisitePublication.profilePositionFile.errors =
      errors["minisite_publication.profilePositionFile"];
    course.minisitePublication.positionFamily.errors =
      errors["minisite_publication.position_family"];
    course.minisitePublication.vacancyRequester.errors =
      errors["minisite_publication.vacancy_requester"];


    course.minisitePublication.desactivateAt.errors =
      errors["minisite_publication.desactivate_at"];
    course.minisitePublication.address.errors =
      errors["minisite_publication.address"];
    course.minisitePublication.country.errors =
      errors["minisite_publication.territory_commune"];
    course.minisitePublication.region.errors =
      errors["minisite_publication.territory_commune"];
    course.minisitePublication.commune.errors =
      errors["minisite_publication.territory_commune"];
    course.minisitePublication.preferredSchedule.errors =
      errors["minisite_publication.preferred_schedule"];
    course.minisitePublication.preferredLaborDay.errors =
      errors["minisite_publication.preferred_labor_day"];
    course.minisitePublication.preferredTurn.errors =
      errors["minisite_publication.preferred_turn"];
    course.minisitePublication.dressCode.errors =
      errors["minisite_publication.dress_code"];
    course.minisitePublication.benefits.errors =
      errors["minisite_publication.benefits"];
    course.contractType.errors = errors.contract_type;

    course.minisitePublication.experienceYears.errors =
      errors["minisite_publication.experience_years"];
    course.minisitePublication.educationLevel.errors =
      errors["minisite_publication.education_level"];
    course.minisitePublication.requirements.errors =
      errors["minisite_publication.requirements"];

    _.map(course.minisitePublication.publicationQuestions, question => {
      if (question.value === "")
        question.errors =
          errors["minisite_publication.publication_questions.name"];
    });

    this.setState({
      ...this.state,
      course
    });
  };

  handleSubmitCourse = async (e = null) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const REQUIRED_FIELDS = [
      { key: 'minisite_publication.requesting_company', label: 'Empresa que Solicita', id: 'requestingCompany' },
      { key: 'minisite_publication.search_type', label: 'Búsqueda', id: 'searchType' },
      { key: 'minisite_publication.position', label: 'Cargo', id: 'position' },
      { key: 'minisite_publication.head', label: 'Jefatura Directa', id: 'head' },
      { key: 'minisite_publication.division', label: 'División', id: 'division' },
      { key: 'minisite_publication.management', label: 'Gerencia', id: 'management' },
      { key: 'minisite_publication.request_reason', label: 'Motivo de Solicitud', id: 'requestReason' },
      { key: 'minisite_publication.buk_id', label: 'ID de BUK', id: 'bukId' },
      { key: 'minisite_publication.recruiter', label: 'Reclutador', id: 'recruiter' },
      { key: 'minisite_publication.location', label: 'Ubicación', id: 'location' },
      { key: 'minisite_publication.position_family', label: 'Familia del cargo', id: 'positionFamily' },
      { key: 'minisite_publication.vacancy_requester', label: 'Quien solicita la vacante', id: 'vacancyRequester' },

      { key: 'title', label: 'Título de publicación', id: 'title' },
      { key: 'job_description', label: 'Descripción del Cargo', id: 'jobDescription' },
      { key: 'minisite_publication.desactivate_at', label: 'Fecha Expiración (30 días máx.)', id: 'desactivateAt' },
      { key: 'minisite_publication.address', label: 'Dirección', id: 'address' },
      { key: 'minisite_publication.commune', label: 'Comuna', id: 'commune' },

      { key: 'minisite_publication.benefits', label: 'Detalle de Beneficios', id: 'benefits' },
      { key: 'contract_type', label: 'Tipo de Contrato', id: 'contractType' },

      { key: 'minisite_publication.experience_years', label: 'Años de Experiencia', id: 'experienceYears' },
      { key: 'minisite_publication.education_level', label: 'Nivel Educacional', id: 'educationLevel' },
      { key: 'minisite_publication.requirements', label: 'Requerimientos Mínimos', id: 'requirements' },
    ];

    const { course } = this.state;

    try {
      const data = await this.serializeData();

      saveCourse(data, response => {
      if (response.status === 200 || response.status === 201) {
        course.id.value = response.data.id;
        course.minisitePublication.id.value =
          response.data.minisitePublication.id;
        course.minisitePublication.aasmState.value = response.data.minisitePublication.aasmState;
        course.minisitePublication.desactivateAt.value = response.data.minisitePublication.desactivateAt;

        course.minisitePublication.publicationQuestions =
          response.data.minisitePublication.publicationQuestions.map(q => ({
            id: q.id,
            value: q.name,
            answerType: q.answer_type || "text",
            isDefault: q.is_default,
            destroy: false,
            errors: []
          }));

        // Actualizar info del archivo si se subió
        if (response.data.minisitePublication.profilePositionFileUrl) {
          course.minisitePublication.profilePositionFileUrl =
            response.data.minisitePublication.profilePositionFileUrl;
          course.minisitePublication.profilePositionFileName =
            response.data.minisitePublication.profilePositionFileName;
        }

        this.setState({ ...this.state.course, course });
        this.toggleTab("publicationPreview");
        this.showNotification("Genial", "Información guardada con éxito", "info");

      } else if (response.status === 400) {
        // Manejar errores de seguridad
        const errorMessage = response.data?.message || response.data?.error || "Error de seguridad detectado";
        this.showNotification("Error de Seguridad", errorMessage, "danger");
        this.setState({ ...this.state, activeTab: "publicationForm" });

      } else if (response.status === 422) {
        console.error('[StepperForm] Validation errors:', response.data);
        console.error('[StepperForm] Full error response:', JSON.stringify(response.data, null, 2));
        this.setErrors(response.data);

        const errors = response.data;
        let firstFieldWithError = null;

        for (const field of REQUIRED_FIELDS) {
          const errorArray = errors[field.key];
          if (errorArray && errorArray.length > 0) {
            firstFieldWithError = field;
            break;
          }
        }

        if (firstFieldWithError) {
          setTimeout(() => {
            const elem = document.getElementById(firstFieldWithError.id);
            if (elem) elem.focus();
          }, 300);

          this.showNotification(
            "Campo requerido",
            `Completa el campo: ${firstFieldWithError.label}`,
            "danger"
          );
        } else {
          this.showNotification("Ops", "Ocurrió un error, revisa el formulario", "danger");
        }
      }
    });
    } catch (error) {
      this.showNotification("Error", error.message, "danger");
    }
  };

  handleSubmitPublication = (e = null) => {
    const { course } = this.state;
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (course.minisitePublication.aasmState.value === "active") {
      window.location.href = `/publications/${course.minisitePublication.id.value}`;
      return;
    }

    const val = course.minisitePublication.desactivateAt.value;
    const picked = val ? new Date(val) : null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (!val || !picked || isNaN(picked) || picked < today) {
      course.minisitePublication.desactivateAt.errors = ["La fecha debe ser hoy o futura"];
      this.setState({ course, activeTab: "publicationForm" });
      this.showNotification(
        "Campo requerido",
        "Completa el campo: Fecha Expiración (30 días máx.)",
        "danger"
      );
      return;
    }

    const data = {
      publication_id: course.minisitePublication.id.value,
      user: this.props.user,
      action: "activate"
    };

    switchState(data, response => {
      if (response.status === 200 || response.status === 201) {
        const id = response.data?.id || course.minisitePublication.id.value;
        window.location.href = `/publications/${id}`;
      } else if (response.status === 422) {
        this.setErrors(response.data);
        this.showNotification("Ops", "Ocurrio un error, revisa el formulario", "danger");
        this.setState({ ...this.state, activeTab: "publicationForm" });
      } else if (response.status === 403) {
        this.showNotification("Ops", response.data, "danger");
      }
    });
  };

  renderHeader = () => {
    switch (this.state.activeTab) {
      case "publicationForm":
        return (
          <p className="small text-muted mb-sm-0">
            Los ítems marcados con asterisco (
            <span className="text-danger font-weight-bold asterics">*</span>
            ) son requeridos para publicar.
          </p>
        );
      case "publicationPreview":
        return (
          <p className="small text-muted mb-sm-0">
            Previsualiza y revisa los detalles de tu publicación. Finaliza el
            proceso haciendo clic en el botón "publicar oferta laboral".
          </p>
        );
      default:
        return null;
    }
  };

  render() {
    const { course, activeTab } = this.state;

    return (
      <div>
        <Notifications ref={this.notificationsRef} />
        <Card className="border-0 mb-4">
          <CardBody className="p-0">
            <Row className="d-flex align-items-center">
              <Col md="6" sm="12">
                <div className="d-block mb-1 d-flex align-items-center">
                  <i className="fas fa-bullhorn fa-pull-left h4 mb-0"></i>
                  <h3 className="h4 mb-0 d-inline-block">
                    Publicar Oferta Laboral
                  </h3>
                </div>
                {this.renderHeader()}
              </Col>
              <Col md="6" sm="12">
                <Nav
                  pills
                  className="nav-justified nav-stepper mt-5 mt-md-4"
                  role="tablist"
                >
                  <NavItem>
                    <NavLink
                      className={
                        "nav-link " +
                        classnames({
                          active: activeTab === "publicationForm"
                        })
                      }
                      onClick={() => {
                        this.toggleTab("publicationForm");
                      }}
                      aria-selected="true"
                      href="#publicationForm"
                      aria-controls="publicationForm"
                      data-toggle="tab"
                      id="publicationForm-tab"
                      aria-label="Oferta Laboral"
                      role="tab"
                    >
                      <button
                        className="btn btn-primary process-step font-weight-bold h2"
                        id="publicationForm_tab_nav"
                      >
                        1
                      </button>
                      <div className="step-data mt-3">
                        <small>Oferta Laboral</small>
                      </div>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={
                        "nav-link " +
                        classnames({
                          active: activeTab === "publicationPreview"
                        })
                      }
                      onClick={() => {
                        this.toggleTab("publicationPreview");
                      }}
                      href="#publicationPreview"
                      aria-controls="publicationPreview"
                      data-toggle="tab"
                      id="publicationPreview-tab"
                      aria-label="Vista Previa"
                      role="tab"
                    >
                      <button
                        className="btn btn-primary process-step font-weight-bold h2"
                        id="publicationPreview_tab_nav"
                      >
                        2
                      </button>
                      <div className="step-data mt-3">
                        <small>Vista Previa</small>
                      </div>
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <TabContent activeTab={activeTab} id="publicationTabContent">
          <TabPane
            id="publicationForm"
            tabId="publicationForm"
            aria-labelledby="publicationForm-tab"
          >
            <PublicationForm
              toggleTab={this.toggleTab}
              course={course}
              handleChangeCourse={this.handleChangeCourse}
              handleChangeMinisitePublication={
                this.handleChangeMinisitePublication
              }
              handleChangeJobDescription={this.handleChangeJobDescription}

              handleChangeBenefits={this.handleChangeBenefits}
              handleAddQuestion={this.handleAddQuestion}
              handleRemoveQuestion={this.handleRemoveQuestion}
              handleChangeQuestion={this.handleChangeQuestion}
              handleChangeQuestionField={this.handleChangeQuestionField}
              handleSubmit={() => this.handleSubmitCourse()}
              isEdit={this.props.isEdit}
            />
          </TabPane>

          <TabPane
            id="publicationPreview"
            tabId="publicationPreview"
            aria-labelledby="publicationPreview-tab"
          >
            <PublicationPreview
              toggleTab={this.toggleTab}
              handleSubmit={() => this.handleSubmitPublication()}
              course={course}
              companyCentral={this.props.companyCentral}
              isEdit={this.props.isEdit}
              onContinue={this.handleContinueWithoutPublishing}
            />
          </TabPane>

        </TabContent>
      </div>
    );
  }
}

export default PublicationStepperForm;
